import { useCallback, useState, useEffect } from "react";
import { serviceLoginUser } from "../../../src/services/index.services";
import { actionLoginUser } from "../../../src/actions/Auth.action";
import { serviceGetThemeByDomain } from "../../../src/services/Client.service";
import SnackbarUtils from "../../../src/libs/SnackbarUtils";
import { useDispatch } from "react-redux";
import historyUtils from "../../../src/libs/history.utils";



const initialForm = {
  contact: "",
};

const useLoginDietitianHook = () => {
  const [form, setForm] = useState({ ...initialForm });
  const [errorData, setErrorData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  

  const dispatch = useDispatch();

  useEffect(() => {
    serviceGetThemeByDomain();
  }, []);

  

  const validate = useCallback((values) => {
    const errors = {};

    if (!values.contact) {
      errors.contact = "Required";
    } else if (values.contact.length > 14) {
      errors.contact = "Must be 13 characters or fewer";
    } else {
      const rawContact = values.contact.replace(/\D/g, ""); 
      if (rawContact.length < 7) {
        errors.contact = "Invalid phone number";
      }
    }
    return errors;
  }, []);

  const removeError = useCallback(
    (field) => {
      setErrorData((prev) => ({ ...prev, [field]: false }));
    },
    []
  );

  const changeTextData = useCallback(
    (text, fieldName) => {
      setForm((prev) => ({ ...prev, [fieldName]: text }));
      removeError(fieldName);
    },
    [removeError]
  );


  const submitToServer = useCallback((data) => {
    setIsSubmitting(true);
    serviceLoginUser(data)
      .then((res) => {
        if (!res.error && res.response_code == 1) {
          SnackbarUtils.success(res?.data?.message || "Otp sent successfully");
          setTimeout(() => {
            historyUtils.push("/otp", { data, res });
          }, 500);
        } else {
          SnackbarUtils.error(res?.message || "Invalid credentials");
        }
      })
      .catch(() => {
        SnackbarUtils.error("Server error");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }, [form, dispatch]);

  const onBlurHandler = useCallback(
    (field) => {
      if (form?.[field]) {
        changeTextData(form[field].trim(), field);
      }
    },
    [form, changeTextData]
  );

  const handleSubmit = useCallback(() => {
    const errors = validate(form);
    if (Object.keys(errors).length > 0) {
      setErrorData(errors);
      return;
    }
    const sanitizedForm = {
      ...form,
      contact: form.contact.replace(/[+-]/g, "")
    };
    submitToServer(sanitizedForm);
  }, [form, validate, submitToServer]);

  return {
    form,
    errorData,
    isSubmitting,
    handleSubmit,
    onBlurHandler,
    changeTextData,
  };
};

export default useLoginDietitianHook;
